import React, { useEffect, useState } from "react";
import { getbalancesheet } from "../../../../services/admin";
import moment from "moment";
import baseUrl from "../../../../Api";
import { printReportUrl } from "../../../../utils/printPdf";

export default function BalanceSheet() {
    const [asOnDate, setAsOnDate] = useState(moment().format("YYYY-MM-DD"));
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchReport();
    }, []);

    const fetchReport = () => {
        setLoading(true);
        const data = {
            as_on_date: asOnDate,
            branch_id: localStorage.getItem("branch"),
        };

        getbalancesheet(data).then((res) => {
            if (res.status === true) {
                console.log("Balance Sheet Response:", res.data);
                setReportData(res.data);
            } else {
                console.error("Balance Sheet Error:", res.message);
            }
            setLoading(false);
        }).catch((error) => {
            console.error("Balance Sheet API Error:", error);
            setLoading(false);
        });
    };

    const handleGenerate = () => {
        fetchReport();
    };

    const handleDownloadPDF = () => {
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch");

        const url = `${baseUrl}/balancesheet/pdf?as_on_date=${asOnDate}&branch_id=${branchId}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `BalanceSheet_${moment(asOnDate).format('DD-MM-YYYY')}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('Error downloading PDF:', error);
            alert('Error downloading PDF');
        });
    };

    // Print sends the same PDF the download button produces straight to the printer.
    const handlePrint = () => {
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch");

        printReportUrl(`${baseUrl}/balancesheet/pdf?as_on_date=${asOnDate}&branch_id=${branchId}&output=html`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });
    };

    const handleDownloadExcel = () => {
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch");

        const url = `${baseUrl}/balancesheet/excel?as_on_date=${asOnDate}&branch_id=${branchId}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `BalanceSheet_${moment(asOnDate).format('DD-MM-YYYY')}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('Error downloading Excel:', error);
            alert('Error downloading Excel');
        });
    };

    const formatCurrency = (amount) => {
        return parseFloat(amount || 0).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Balance Sheet</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Accounts</a>
                    </li>
                    <li className="breadcrumb-item">
                        <a>Reports</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Balance Sheet
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4 className="card-title">Balance Sheet</h4>
                                        </div>
                                        <div className="col-md-6 text-end">
                                            {reportData && (
                                                <>
                                                    <button className="btn btn-danger me-2" onClick={handleDownloadPDF}>
                                                        <i className="fa fa-file-pdf"></i> Download PDF
                                                    </button>
                                                    <button className="btn btn-success me-2" onClick={handleDownloadExcel}>
                                                        <i className="fa fa-file-excel"></i> Download Excel
                                                    </button>
                                                    <button className="btn btn-primary" onClick={handlePrint}>
                                                        <i className="fa fa-print"></i> Print
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                            <div className="row mb-4">
                                <div className="col-md-4">
                                    <label className="form-label">As On Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={asOnDate}
                                        onChange={(e) => setAsOnDate(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-2 d-flex align-items-end">
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleGenerate}
                                        disabled={loading}
                                    >
                                        <i className="fa fa-search"></i> {loading ? 'Loading...' : 'Generate'}
                                    </button>
                                </div>
                            </div>

                            {reportData && (
                                <>
                                    <div className="text-center mb-4">
                                        <h5>Balance Sheet</h5>
                                        <p className="text-muted">
                                            As on {moment(reportData.as_on_date || asOnDate).format('DD-MM-YYYY')}
                                        </p>
                                    </div>

                                    <div className="row">
                                        {/* Liabilities and Equity Side */}
                                        <div className="col-md-6">
                                            <div className="table-responsive">
                                                <table className="table table-bordered">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th colSpan="2">LIABILITIES & EQUITY</th>
                                                            <th className="text-end">Amount (₹)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* Equity Section */}
                                                        <tr className="table-info">
                                                            <td colSpan="3"><strong>EQUITY</strong></td>
                                                        </tr>

                                                        {Object.entries(reportData.equity?.groups || {}).map(([groupName, groupData], idx) => (
                                                            <React.Fragment key={`equity-group-${idx}`}>
                                                                <tr>
                                                                    <td colSpan="3" className="ps-3">
                                                                        <strong>{groupName}</strong>
                                                                    </td>
                                                                </tr>
                                                                {groupData.accounts.map((account, accIdx) => (
                                                                    <tr key={`equity-acc-${accIdx}`}>
                                                                        <td width="5%"></td>
                                                                        <td>{account.account_name}</td>
                                                                        <td width="30%" className="text-end">
                                                                            {formatCurrency(account.amount)}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </React.Fragment>
                                                        ))}

                                                        {(reportData.equity?.retained_earnings || 0) !== 0 && (
                                                            <tr>
                                                                <td></td>
                                                                <td>Retained Earnings</td>
                                                                <td className="text-end">
                                                                    {formatCurrency(reportData.equity?.retained_earnings || 0)}
                                                                </td>
                                                            </tr>
                                                        )}

                                                        <tr className="table-secondary">
                                                            <td colSpan="2"><strong>TOTAL EQUITY</strong></td>
                                                            <td className="text-end">
                                                                <strong>{formatCurrency(reportData.equity?.total || 0)}</strong>
                                                            </td>
                                                        </tr>

                                                        {/* Liabilities Section */}
                                                        <tr className="table-warning">
                                                            <td colSpan="3"><strong>LIABILITIES</strong></td>
                                                        </tr>

                                                        {Object.entries(reportData.liabilities?.groups || {}).map(([groupName, groupData], idx) => (
                                                            <React.Fragment key={`liability-group-${idx}`}>
                                                                <tr>
                                                                    <td colSpan="3" className="ps-3">
                                                                        <strong>{groupName}</strong>
                                                                    </td>
                                                                </tr>
                                                                {groupData.accounts.map((account, accIdx) => (
                                                                    <tr key={`liability-acc-${accIdx}`}>
                                                                        <td></td>
                                                                        <td>{account.account_name}</td>
                                                                        <td className="text-end">
                                                                            {formatCurrency(account.amount)}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </React.Fragment>
                                                        ))}

                                                        <tr className="table-secondary">
                                                            <td colSpan="2"><strong>TOTAL LIABILITIES</strong></td>
                                                            <td className="text-end">
                                                                <strong>{formatCurrency(reportData.liabilities?.total || 0)}</strong>
                                                            </td>
                                                        </tr>

                                                        {/* Total Liabilities + Equity */}
                                                        <tr className="table-primary">
                                                            <td colSpan="2"><strong>TOTAL LIABILITIES & EQUITY</strong></td>
                                                            <td className="text-end">
                                                                <strong>{formatCurrency(reportData.total_liabilities_and_equity || 0)}</strong>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {/* Assets Side */}
                                        <div className="col-md-6">
                                            <div className="table-responsive">
                                                <table className="table table-bordered">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th colSpan="2">ASSETS</th>
                                                            <th className="text-end">Amount (₹)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Object.entries(reportData.assets?.groups || {}).map(([groupName, groupData], idx) => (
                                                            <React.Fragment key={`asset-group-${idx}`}>
                                                                <tr className="table-info">
                                                                    <td colSpan="3">
                                                                        <strong>{groupName}</strong>
                                                                    </td>
                                                                </tr>
                                                                {groupData.accounts.map((account, accIdx) => (
                                                                    <tr key={`asset-acc-${accIdx}`}>
                                                                        <td width="5%"></td>
                                                                        <td>{account.account_name}</td>
                                                                        <td width="30%" className="text-end">
                                                                            {formatCurrency(account.amount)}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                                <tr className="table-secondary">
                                                                    <td colSpan="2" className="ps-3">
                                                                        <strong>Total {groupName}</strong>
                                                                    </td>
                                                                    <td className="text-end">
                                                                        <strong>{formatCurrency(groupData.total)}</strong>
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>
                                                        ))}

                                                        {/* Total Assets */}
                                                        <tr className="table-primary">
                                                            <td colSpan="2"><strong>TOTAL ASSETS</strong></td>
                                                            <td className="text-end">
                                                                <strong>{formatCurrency(reportData.assets?.total || 0)}</strong>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    {reportData.is_balanced && (
                                        <div className="alert alert-success mt-3">
                                            <i className="fa fa-check-circle"></i> Balance Sheet is balanced!
                                            Assets = Liabilities + Equity
                                        </div>
                                    )}

                                    {!reportData.is_balanced && (
                                        <div className="alert alert-danger mt-3">
                                            <i className="fa fa-exclamation-triangle"></i> Balance Sheet is not balanced!
                                            Difference: ₹{formatCurrency(Math.abs(reportData.difference || 0))}
                                        </div>
                                    )}
                                </>
                            )}

                            {!reportData && !loading && (
                                <div className="text-center py-5">
                                    <p className="text-muted">Click "Generate" to view the Balance Sheet</p>
                                </div>
                            )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
